export enum Theme {
  dark = 'dark',
  light = 'light',
}

export enum LanguageCodes {
  en = 'en',
}
